import * as Yup from "yup";

export const initialValuesInvitations = {
    "description": ""
}

export const validationSchemaInvitations = Yup.object().shape({
    "description": Yup.string().required('El nombre de la invitación es requerido.')
})